import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { groupItemMixin, jsonGroupItemMixin } from '@/views/creative/mixin';
import AlertMessage from '../alert-message.vue';
import { Base64 } from 'js-base64';
import LanguageInfoEditor from '../language-info-editor.vue';
import { cookStyle } from '@/views/creative/utils/cook-style-schema.js';
import LanguageSelector from '../language-selector.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { isCommonI18n } from '@/store/creative/common';
import AiTranslate from '@com/components/ai-translate';
import CategoryI18nDialog from '@/views/creative/components/i18n/category-i18n-dialog';

export default {
  mixins: [groupItemMixin, jsonGroupItemMixin],

  components: {
    CategoryI18nDialog: CategoryI18nDialog,
    AlertMessage: AlertMessage,
    LanguageInfoEditor: LanguageInfoEditor,
    LanguageSelector: LanguageSelector,
    AiTranslate: AiTranslate
  },

  props: {
    languages: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    templateConfig: {
      type: Object
    }
  },

  data: function data() {
    return {
      model: null,
      formConfig: {
        labelPosition: 'top',
        size: 'small',
        inline: false
      },

      error: [],

      languagesAdditionalItems: null,

      saveLanguageDialog: {
        title: this.$t('playTurbo.creative.languagePacks.addLanguageButton'),
        visible: false,
        loading: false
      },

      styleEditorDialog: {
        visible: false
      },
      styleEditor: {
        schema: null,
        model: null,
        __local: '',
        textKey: ''
      },
      categoryDialog: {
        visible: false
      },
      languageMode: 'create'
    };
  },


  computed: _extends({}, mapState({
    page: function page(state) {
      return state.creative.template.page;
    },
    projectId: function projectId(state) {
      return state.creative.template.id;
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    isTemplate: function isTemplate(state) {
      return state.creative.template.isTemplate;
    },
    i18nResource: function i18nResource(state) {
      return state.creative.template.i18nResource;
    },
    templateConfigCategory: function templateConfigCategory(state) {
      return state.creative.template.templateConfig.category;
    }
  }), {
    sceneList: function sceneList() {
      var sceneList = [];
      var rec = function rec(category) {
        if (category.resource_type === 'scene') {
          sceneList.push({
            id: category.id,
            name: category.name,
            name_en: category.name_en
          });
        } else if (category.sub_category && category.sub_category.length > 0) {
          category.sub_category.forEach(function (item) {
            rec(item);
          });
        }
      };
      if (this.templateConfigCategory && this.templateConfigCategory.length) {
        this.templateConfigCategory.forEach(function (item) {
          rec(item);
        });
      }
      return sceneList;
    },
    addLanguageButton: function addLanguageButton() {
      return {
        type: 'text',
        text: this.$t('playTurbo.creative.languagePacks.addLanguageButton'),
        disabled: this.addableLanguageList.length === 0
      };
    },
    isLanguageEditable: function isLanguageEditable() {
      // 模板页面一直可以增加
      if (this.hasPermission('language.add-and-delete')) return true;
      // 其他页面根据 allow_add_language 的值控制是否开放这个功能
      return this.templateConfig.allow_add_language === 1;
    },
    languageSourceLists: function languageSourceLists() {
      return this.$store.getters.languages;
    },
    projectLanguages: function projectLanguages() {
      var _this = this;

      var projectLanguages = {};
      var stages = [{
        stage: 'start',
        title: this.$t('playTurbo.creative.languagePacks.leadSession')
      }, {
        stage: 'game',
        title: this.$t('playTurbo.creative.languagePacks.gameSession')
      }, {
        stage: 'ending',
        title: this.$t('playTurbo.creative.languagePacks.endSession')
      }];

      var _loop = function _loop(key) {
        projectLanguages[key] = [];
        // 根据项目的 language 信息，生成组件所需要的 projectLanguages
        _.each(_this.languages.languages[key], function (item, k) {
          var parent = '';
          var parentIndex = -1;
          // 如果有 stage 字段，代表是历史素材，需要按照 stages 里面的顺序排序
          if (item.stage) {
            parent = stages.find(function (stage) {
              return stage.stage === item.stage;
            }).title;
            parentIndex = stages.findIndex(function (stage) {
              return stage.stage === item.stage;
            });
          } else if (item.scene) {
            parent = item.scene;
            if (_this.sceneList.length > 0) {
              parentIndex = _this.sceneList.findIndex(function (scene) {
                return scene.name === item.scene || scene.name_en === item.scene;
              });
            } else {
              parentIndex = -1;
            }
          }
          // 如果是横屏，则返回，只需要保留竖屏即可
          // 只有 ps 产出的素材才分横竖屏，而 ps 产出的素材是有 scene 属性的，所以 cookStageModel 那里不需要判断方向的逻辑
          if (_this.getDirection(k) === 'H') {
            return;
          }
          var value = item.value;
          // 多组合场景中，需要获取第一个文本版本的值
          // 为啥这样子改，因为多组合场景中，最后编辑的文本会覆盖 this.languages.languages 中的值, 即使删除了这个版本，值还是以最后编辑的为准，所以需要从 this.i18nResource 中获取最新的值
          if (_this.i18nResource[k] && _this.i18nResource[k][0] && _this.i18nResource[k][0].data && _this.i18nResource[k][0].data[key]) {
            value = _this.i18nResource[k][0].data[key].value;
          }
          projectLanguages[key].push({
            key: k,
            parent: parent,
            parentIndex: parentIndex,
            value: value
          });
        });
      };

      for (var key in this.languages.languages) {
        _loop(key);
      }
      return projectLanguages;
    },
    languageList: function languageList() {
      return this.$store.getters.languages.map(function (item) {
        return {
          value: item.code,
          label: item.name
        };
      });
    },
    currentLanguageCodeList: function currentLanguageCodeList() {
      if (this.model && this.model.languages.length > 0) {
        return this.model.languages.map(function (item) {
          return item.__local;
        });
      }
      return [];
    },


    // 非法语言列表，不在素材仓库语言接口里面的语言
    illegalLanguageList: function illegalLanguageList() {
      var _this2 = this;

      if (this.currentLanguageCodeList && this.languageList.length > 0) {
        return this.currentLanguageCodeList.filter(function (code) {
          return _this2.languageList.every(function (language) {
            return language.value !== code;
          });
        }).map(function (code) {
          return {
            value: code,
            label: code
          };
        });
      }
      return [];
    },
    legalLanguageList: function legalLanguageList() {
      var _this3 = this;

      if (this.currentLanguageCodeList && this.languageList.length > 0) {
        return this.languageList.filter(function (language) {
          return _this3.currentLanguageCodeList.some(function (code) {
            return code === language.value;
          });
        });
      }
      return [];
    },


    // 可新增的语言，过滤已有的语言
    addableLanguageList: function addableLanguageList() {
      var _this4 = this;

      if (this.currentLanguageCodeList && this.languageList.length > 0) {
        return this.languageList.filter(function (language) {
          return _this4.currentLanguageCodeList.every(function (code) {
            return code !== language.value;
          });
        }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
      }
      return [];
    },
    currentLanguageList: function currentLanguageList() {
      return [].concat(_toConsumableArray(this.illegalLanguageList), _toConsumableArray(this.legalLanguageList));
    },
    visible: function visible() {
      if (this.languages && this.languages.fallbackLocale && this.languages.languages) {
        return true;
      }

      return false;
    },
    currentLanguage: function currentLanguage() {
      var _this5 = this;

      return this.model.languages.filter(function (item) {
        return item.__local === _this5.model.fallbackLocale;
      });
    },


    // 项目类型，portal 为模板，gm 为通用模板，dm 为定制模板
    projectSource: function projectSource() {
      if (this.isTemplate) {
        return 'portal';
      } else if (this.isCommonTemplateCustom) {
        return 'gm';
      }
      return 'dm';
    }
  }),

  watch: {
    model: {
      handler: function handler(val) {
        var conf = _extends({}, this.model);
        conf.languages = this.languagesToObject(conf.languages);
        this.$emit('update', conf);
      },

      deep: true
    }
  },

  mounted: function mounted() {
    var _this6 = this;

    if (this.visible) {
      this.model = {
        fallbackLocale: this.languages.fallbackLocale,
        languages: this.languagesToArray(this.languages.languages)

        // 必须配置了兜底语言
      };if (this.model.languages.some(function (language) {
        return language.__local === _this6.model.fallbackLocale;
      })) {
        if (this.languageList && !this.languageList.length) {
          this.$store.dispatch('config/getLanguagesList');
        }

        this.languagesAdditionalItems = this.getLanguagesAdditionalItems();

        this.$nextTick(function () {
          _this6.$refs.form && _this6.$refs.form.validate && _this6.$emit('add-validator', _this6.$refs.form.validate);
        });
      } else {
        this.error.push({
          message: '' + this.$t('playTurbo.creative.languagePacks.warning1') + this.model.fallbackLocale
        });
      }
    }

    document.addEventListener('click', this.closeStyleEditorDialog);
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.closeStyleEditorDialog);
  },


  methods: _extends({}, mapMutations({
    addValidator: 'creative/template/addValidator',
    updateTargetI18nResource: 'creative/template/updateTargetI18nResource',
    updateNotSceneI18nResource: 'creative/template/updateNotSceneI18nResource'
  }), mapActions({
    addI18nLanguage: 'creative/template/addI18nLanguage',
    deleteI18nLanguage: 'creative/template/deleteI18nLanguage',
    updateTargetLanguageAll18nResource: 'creative/template/updateTargetLanguageAll18nResource'
  }), {

    omit: _.omit,

    isLanguagesRemovable: function isLanguagesRemovable(local) {
      // 兜底语言不可
      if (this.model.fallbackLocale === local) {
        return false;
      }

      return true;
    },
    getLanguagesAdditionalItems: function getLanguagesAdditionalItems() {
      var _this7 = this;

      var fallbackLanguage = this.languages.languages[this.languages.fallbackLocale];
      _.each(fallbackLanguage, function (item, key) {
        fallbackLanguage[key] = item;
      });

      var schema = {
        type: 'object',
        properties: {},
        default: _extends({
          __local: ''
        }, fallbackLanguage)
      };
      _.each(this.languages.languages[this.languages.fallbackLocale], function (item, key) {
        schema.properties[key] = {
          type: 'object',
          border: false,
          class: 'text-form-fieldset',
          style: { 'margin-bottom': '0', padding: '0' },
          properties: {
            value: {
              component: 'input',
              label: Base64.decode(key),
              rules: [{
                required: true,
                trigger: 'blur',
                message: _this7.$t('playTurbo.creative.languagePacks.properties.required')
              }],
              field: {
                type: 'textarea',
                autosize: true
                // placeholder: `请填写${key}`
              }
            }
            // style: getStyleSchema(key.style)
          }
        };
      });
      return schema;
    },


    /**
     * @param {{}} languages
     */
    languagesToArray: function languagesToArray(languages) {
      var cloneLanguages = _.cloneDeep(languages);
      _.each(cloneLanguages, function (language, key) {
        language.__local = key;
      });
      return _.toArray(cloneLanguages);
    },


    /**
     * @param {[]} languages
     */
    languagesToObject: function languagesToObject(languages) {
      var cloneLanguages = _.cloneDeep(languages);
      var newLanguages = {};
      _.each(cloneLanguages, function (language, key) {
        var __local = language.__local;
        delete language.__local;
        newLanguages[__local] = language;
      });
      return newLanguages;
    },
    openSaveLanguageDialog: function openSaveLanguageDialog() {
      this.saveLanguageDialog.visible = true;
      this.saveLanguageDialog.title = this.$t('playTurbo.creative.languagePacks.addLanguageButton');
      this.languageMode = 'create';
      if (this.$refs.aiTranslate && this.$refs.aiTranslate.resetData) {
        this.$refs.aiTranslate.resetData();
      }
    },
    closeSaveLanguageDialog: function closeSaveLanguageDialog() {
      this.saveLanguageDialog.visible = false;
      this.saveLanguageDialog.loading = false;
    },
    handleLanguagePackSubmit: function handleLanguagePackSubmit(language) {
      this.closeSaveLanguageDialog();
      this.addLanguage(language);
    },
    addLanguage: function addLanguage(language) {
      var _this8 = this;

      this.model.languages.push(language);

      this.$nextTick(function () {
        _this8.addI18nLanguage({ language: language, local: language.__local });
      });
    },
    delLanguage: function delLanguage(language) {
      var _this9 = this;

      this.model.languages.splice(this.model.languages.findIndex(function (item) {
        return item.__local === language;
      }), 1);
      this.$nextTick(function () {
        _this9.deleteI18nLanguage({ language: language });
      });
    },
    handleLanguageInfoSubmit: function handleLanguageInfoSubmit(info) {
      info.model.style = cookStyle(_.cloneDeep(info.model.style || null));

      this.model.languages = this.model.languages.map(function (item) {
        if (item.__local === info.local) {
          item[info.key] = info.model;
          return _extends({}, item);
        }
        return _extends({}, item);
      });
    },
    decode: function decode(val) {
      return Base64.decode(val);
    },
    selectLanguage: function selectLanguage(val) {
      this.model.fallbackLocale = val;
      this.$store.commit('creative/template/updateCurrentLanguage', val);
    },
    isShowLanguage: function isShowLanguage(languages) {
      if (languages === null || languages.length === 0) {
        return false;
      }
      for (var i in languages) {
        var language = this.omit(languages[i], ['__local']);
        for (var j in language) {
          if (this.isShowLanguageInfoEditor(language[j])) {
            return true;
          }
        }
      }
      // 所有代码字都不展示就隐藏整块内容
      return false;
    },
    isShowLanguageInfoEditor: function isShowLanguageInfoEditor(info) {
      // PlayTurbo第二版显示逻辑,兼容第一版
      if (isCommonI18n(info)) {
        return true;
      }
      return false;
    },
    createLang: function createLang() {
      var _this10 = this;

      this.saveLanguageDialog.loading = true;
      this.$refs.aiTranslate.validate(function (valid) {
        if (valid) {
          var translateData = _this10.$refs.aiTranslate.getTranslateData();
          if (_this10.languageMode === 'create') {
            var languages = {};
            _.each(translateData, function (item, key) {
              languages.__local = key;
              // 重新生成语言包
              _.each(_this10.model.languages[0], function (i, k) {
                if (k !== '__local') {
                  // 因为组件只保留竖屏的数据，如果是竖屏的数据需要用横盘的 value 去覆盖
                  if (_this10.getDirection(k) === 'H') {
                    // 竖屏文本
                    var langModel = item.find(function (j) {
                      return j.key === _this10.getAnotherDirectionKey(k);
                    });
                    languages[k] = _extends({}, i, {
                      // 获取这个竖屏文本
                      value: langModel ? langModel.value : i.value
                    });
                  } else {
                    var _langModel = item.find(function (j) {
                      return j.key === k;
                    });
                    languages[k] = _extends({}, i, {
                      value: _langModel ? _langModel.value : i.value
                    });
                  }
                }
              });
            });
            _this10.handleLanguagePackSubmit(languages);
          } else {
            _.each(translateData, function (item, lang) {
              _.each(item, function (i) {
                var key = i.key;
                var value = i.value;
                if (_.isUndefined(_this10.i18nResource[key])) {
                  _this10.updateNotSceneI18nResource({
                    key: key,
                    language: lang,
                    value: {
                      value: value
                    }
                  });
                } else {
                  // 如果是竖屏文本，需要把横屏文本也更新
                  if (_this10.getDirection(key)) {
                    _this10.updateTargetI18nResource({
                      key: _this10.getAnotherDirectionKey(key),
                      index: 0,
                      language: lang,
                      value: {
                        value: value
                      }
                    });
                  }
                  _this10.updateTargetI18nResource({
                    key: key,
                    index: 0,
                    language: lang,
                    value: {
                      value: value
                    }
                  });
                }
              });
            });
            // 更新文案
            _this10.model.languages = _this10.languagesToArray(_this10.languages.languages);
            _this10.closeSaveLanguageDialog();
          }
        } else {
          _this10.saveLanguageDialog.loading = false;
        }
      });
    },
    getAnotherDirectionKey: function getAnotherDirectionKey(key) {
      // 区分横竖屏文本
      var anotherDirectionKey = '';
      var decodedKey = this.decode(key);
      if (/_v$/i.test(decodedKey)) {
        anotherDirectionKey = decodedKey.replace(/_v$/i, '_H');
      } else if (/_h$/i.test(decodedKey)) {
        anotherDirectionKey = decodedKey.replace(/_h$/i, '_V');
      }
      return Base64.encode(anotherDirectionKey);
    },
    getDirection: function getDirection(key) {
      // 区分横竖屏文本
      var direction = '';
      var decodedKey = this.decode(key);
      if (/_v$/i.test(decodedKey)) {
        direction = 'V';
      } else if (/_h$/i.test(decodedKey)) {
        direction = 'H';
      }
      return direction;
    },
    openModifyLanguageDialog: function openModifyLanguageDialog() {
      this.saveLanguageDialog.visible = true;
      this.saveLanguageDialog.title = this.$t('playTurbo.creative.languagePacks.changeLanguageButton');
      this.languageMode = 'edit';
      if (this.$refs.aiTranslate && this.$refs.aiTranslate.resetData) {
        this.$refs.aiTranslate.resetData();
      }
    },

    // 一键应用到语言
    handleApplyBtnSubmit: function handleApplyBtnSubmit(_ref) {
      var model = _ref.model,
          local = _ref.local,
          key = _ref.key;

      var style = cookStyle(_.cloneDeep(model.style || null));
      _.forEach(this.model.languages, function (localItem) {
        if (localItem.__local !== local) {
          localItem[key].style = _extends({}, style, {
            font: localItem[key].style.font,
            fontSize: localItem[key].style.fontSize
          });
        }
      });
      this.$message.success(this.$t('playTurbo.custom.textEditButton.languageAlert'));
    },

    // 应用到同语言的所有文本
    applyFontToOtherTextNode: function applyFontToOtherTextNode(_ref2) {
      var model = _ref2.model,
          local = _ref2.local;

      this.updateTargetLanguageAll18nResource({
        style: model.style,
        language: local
      });
      // 更新
      this.model.languages = this.languagesToArray(this.languages.languages);
      this.$message.success(this.$t('basic.fontLoader.applyFontSuccess'));
    }
  })
};